import VehicleDriverInfoDetailModal from './vehicle-driver-info-detail-modal.vue'
export default VehicleDriverInfoDetailModal
